import React from 'react'

const HumanIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9531 9.3917H2.08484C0.935018 9.3917 0 9.92292 0 11.466C0 13.0091 0.745487 14.4004 2.14801 15.2984C3.38628 16.0826 5.06679 16.5 7 16.5C8.93321 16.5 10.6264 16.0826 11.852 15.2984C13.2545 14.4004 14 13.0723 14 11.466C14 9.85968 13.065 9.3917 11.9278 9.3917H11.9531ZM7.01264 15.3237C5.31949 15.3237 3.81588 14.9569 2.79242 14.2992C1.73105 13.6162 1.18773 12.8953 1.18773 11.466C1.18773 10.8083 1.59206 10.5806 2.08484 10.5806H11.9531C12.4458 10.5806 12.8375 10.9854 12.8375 11.466C12.8375 12.6676 12.2942 13.6162 11.2329 14.2992C10.2094 14.9569 8.70578 15.3237 7.01264 15.3237Z"
        fill="white"
      />
      <path
        d="M7 8.59486C9.23646 8.59486 11.056 6.78617 11.056 4.56008C11.056 2.33399 9.2491 0.5 7.01264 0.5C4.77617 0.5 2.95668 2.32134 2.95668 4.54743C2.95668 6.77352 4.77617 8.59486 7 8.59486ZM7.01264 1.68893C8.59206 1.68893 9.88087 2.97905 9.88087 4.56008C9.88087 6.14111 8.59206 7.43123 7.01264 7.43123C5.43321 7.43123 4.1444 6.14111 4.1444 4.56008C4.1444 2.97905 5.43321 1.68893 7.01264 1.68893Z"
        fill="white"
      />
    </svg>
  )
}

export default HumanIcon
